import React, { forwardRef } from 'react';

import { Button, ButtonProps } from 'src/components/atoms/Button';
import { ICON_BUTTON__BUTTON_CLASS, ICON_BUTTON__ICON_CLASS } from './constants/classNames';
import * as styles from './styles';

export type IconButtonProps = ButtonProps & {
  icon: string;
  iconWidth: number;
  iconHeight: number;
};

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ children, icon, iconWidth, iconHeight, ...buttonProps }: IconButtonProps, forwardedRef) => (
    <Button
      className={ICON_BUTTON__BUTTON_CLASS}
      css={styles.iconButton}
      ref={forwardedRef}
      {...buttonProps}
    >
      <img
        className={ICON_BUTTON__ICON_CLASS}
        src={icon}
        alt=""
        width={iconWidth}
        height={iconHeight}
      />
      {children}
    </Button>
  ),
);
